<template>
  <div class="product__descriptions product-descriptions">
    <div class="product-descriptions__wrap" v-for="(description, i) in descriptions" :key="i">
      <div v-if="descriptions.length === 1"
           class="product-descriptions__item product-descriptions__item--single"
           :class="{'product-custom-description pcd': description.html_description}"
           v-html="description.description"></div>
      <div
        v-else
        class="product-descriptions__item"
        :class="{'reverse': i % 2 === 1}"
      >
        <div class="product-descriptions__text">
          <div class="product-descriptions__text-wrap">
            <h2 class="product-descriptions__title">
              {{ description.title }}
            </h2>
            <div class="product-descriptions__info" v-html="description.description"></div>
          </div>
        </div>
        <div class="product-descriptions__img">
          <img
            loading="lazy"
            data-force-load="true"
            :src="description.photo"
            :alt="`Характеристика товару «${description.title}» - фото №${i}`"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ProductDescriptions',
  computed: {
    ...mapState({
      title: state => state.productInfo.productInfo.title,
      descriptions: state => state.productInfo.productInfo.descriptions
    })
  }
}
</script>

<style scoped lang="sass">

.product-descriptions__item
  display: flex
  flex-flow: column-reverse
  align-items: center
  margin-bottom: 30px

  +mmin($tablet)
    flex-flow: row
    margin-bottom: 40px

  &--single
    display: block
    font-weight: 400

.product-descriptions__item.reverse
  +mmin($tablet)
    flex-flow: row-reverse

.product-descriptions__text,
.product-descriptions__img
  width: 100%
  text-align: left

  +mmin($tablet)
    width: 50%
    padding: 0 15px

.product-descriptions__text-wrap
  width: max-content
  max-width: 100%
  margin: 0 auto

.product-descriptions__title
  font-size: 24px
  font-weight: 400
  margin: 0 0 30px

.product-descriptions__info
  color: #4c4c4c
  font-size: 16px
  font-weight: 400
  line-height: 160%

  +mmin($tablet)
    max-width: 500px

.product-descriptions__img
  margin-bottom: 30px

  +mmin($tablet)
    margin-bottom: 0

  img
    width: 100%
    display: block

</style>
